/* Leo Marbella · Productos relacionados por etiquetas (lm-genero-*, lm-tipo-*, lm-estilo-*) · 10/10/2026 */
(function () {
  function lmRelInit(root) {
    if (!root || root.dataset.lmInit) return;
    root.dataset.lmInit = '1';

    var track = root.querySelector('[data-lm-track]');
    var prev = root.querySelector('[data-lm-prev]');
    var next = root.querySelector('[data-lm-next]');

    var productId = String(root.dataset.productId || '');
    var limit = parseInt(root.dataset.limit, 10) || 8;
    var intent = root.dataset.intent || 'related';
    var baseUrl = root.dataset.url || '/recommendations/products';
    var mode = root.dataset.lmMode;
    var wantGender = (root.dataset.lmGender || '').toLowerCase();
    var curTitle = root.dataset.lmTitle || '';
    var wantType = (root.dataset.lmType || '').toLowerCase();
    var wantStyle = (root.dataset.lmStyle || '').toLowerCase();

    if (!productId || !track) { root.hidden = true; return; }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function moneyCents(cents) { return (Number(cents) / 100).toFixed(2).replace('.', ',') + ' €'; }
    function moneyEuros(str) { return Number(str).toFixed(2).replace('.', ',') + ' €'; }

    function shuffle(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
      }
      return arr;
    }

    function optionLabel(name) {
      var n = String(name || '').toLowerCase();
      if (n.indexOf('col') > -1 || n.indexOf('kleur') > -1 || n.indexOf('farbe') > -1) return 'tu color';
      if (n.indexOf('tall') > -1 || n.indexOf('size') > -1 || n.indexOf('taille') > -1 || n.indexOf('maat') > -1 || n.indexOf('gr') > -1) return 'tu talla';
      return n;
    }

    /* Tarjeta a partir de /products.json (precios en euros, en texto) */
    function cardFromCatalog(p) {
      var url = '/products/' + p.handle;
      var img = p.images && p.images.length ? p.images[0].src : '';
      var variants = p.variants || [];
      var firstAvail = variants.filter(function (v) { return v.available; })[0] || variants[0];
      var price = firstAvail ? firstAvail.price : '0';
      var compare = firstAvail ? firstAvail.compare_at_price : null;
      var onSale = compare && Number(compare) > Number(price);

      var html = '<article class="lm-rel__card">'
        + '<a class="lm-rel__media" href="' + url + '">'
        + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '')
        + (onSale ? '<span class="lm-rel__badge">Oferta</span>' : '')
        + '</a>'
        + '<a class="lm-rel__name" href="' + url + '">' + escapeHtml(p.title) + '</a>'
        + '<p class="lm-rel__price">'
        + (onSale ? '<span class="lm-rel__price-was">' + moneyEuros(compare) + '</span>' : '')
        + '<span class="lm-rel__price-now">' + moneyEuros(price) + '</span>'
        + '</p>';

      var opts = p.options || [];
      var single = variants.length === 1 && opts.length === 1 && String(opts[0].values && opts[0].values[0]).toLowerCase() === 'default title';

      if (!single && opts.length) {
        var labels = opts.map(function (o) { return optionLabel(o.name); }).join(' y ');
        var vars = variants.map(function (v) {
          var o = [];
          for (var k = 1; k <= opts.length; k++) o.push(v['option' + k]);
          return { id: v.id, o: o, a: !!v.available, i: v.img || null };
        });
        html += '<div class="lm-rel__opts" data-lm-opts>'
          + '<p class="lm-rel__opts-label">Selecciona ' + escapeHtml(labels) + '</p>'
          + '<div class="lm-rel__sel">';
        opts.forEach(function (o, idx) {
          var selected = firstAvail ? firstAvail['option' + (idx + 1)] : null;
          html += '<select data-lm-opt aria-label="' + escapeHtml(o.name) + '">';
          (o.values || []).forEach(function (val) {
            html += '<option value="' + escapeHtml(val) + '"' + (val === selected ? ' selected' : '') + '>' + escapeHtml(val) + '</option>';
          });
          html += '</select>';
        });
        html += '</div><script type="application/json" data-lm-vars>' + JSON.stringify(vars).replace(/</g, '\\u003c') + '<\/script></div>';
      }

      html += firstAvail
        ? '<button type="button" class="lm-rel__btn" data-lm-add="' + firstAvail.id + '">Añadir al carrito</button>'
        : '<a class="lm-rel__btn" href="' + url + '">Ver producto</a>';

      return html + '</article>';
    }

    /* Tarjeta a partir de las recomendaciones automáticas de Shopify (precios en céntimos) */
    function cardFromRecs(p) {
      var img = p.featured_image
        ? '<img src="' + p.featured_image + '&width=600" alt="' + escapeHtml(p.title) + '" loading="lazy">'
        : '';
      var onSale = p.compare_at_price && p.compare_at_price > p.price;
      var variantId = p.variants && p.variants.length ? p.variants[0].id : null;
      var available = p.available && variantId;

      return '<article class="lm-rel__card">'
        + '<a class="lm-rel__media" href="' + p.url + '">' + img
        + (onSale ? '<span class="lm-rel__badge">Oferta</span>' : '')
        + '</a>'
        + '<a class="lm-rel__name" href="' + p.url + '">' + escapeHtml(p.title) + '</a>'
        + '<p class="lm-rel__price">'
        + (onSale ? '<span class="lm-rel__price-was">' + moneyCents(p.compare_at_price) + '</span>' : '')
        + '<span class="lm-rel__price-now">' + moneyCents(p.price) + '</span>'
        + '</p>'
        + (available
          ? '<button type="button" class="lm-rel__btn" data-lm-add="' + variantId + '">Añadir al carrito</button>'
          : '<a class="lm-rel__btn" href="' + p.url + '">Ver producto</a>')
        + '</article>';
    }

    function paint(html) {
      if (!html) { root.hidden = true; return; }
      track.innerHTML = html;
      updateArrows();
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    function step() {
      var card = track.querySelector('.lm-rel__card');
      if (!card) return track.clientWidth;
      return card.getBoundingClientRect().width + 18;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateArrows, { passive: true });

    /* Elegir color y talla en la propia tarjeta */
    track.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-lm-opt]');
      if (!sel) return;
      var card = sel.closest('.lm-rel__card');
      var box = card && card.querySelector('[data-lm-opts]');
      var btn = card && card.querySelector('[data-lm-add]');
      var data = box && box.querySelector('[data-lm-vars]');
      if (!btn || !data) return;
      var vals = Array.prototype.map.call(box.querySelectorAll('[data-lm-opt]'), function (s) { return s.value; });
      var vars = [];
      try { vars = JSON.parse(data.textContent); } catch (err) { return; }
      var match = vars.filter(function (v) { return v.o.join('||') === vals.join('||'); })[0]; var lmIm = card.querySelector('.lm-rel__media img'); var lmSrc = match && match.i ? match.i : (vars.filter(function (v) { return v.o[0] === vals[0] && v.i; })[0] || {}).i; if (lmIm && lmSrc) { lmIm.src = lmSrc + (lmSrc.indexOf('?') > -1 ? '&' : '?') + 'width=600'; }
      if (match && match.a) {
        btn.setAttribute('data-lm-add', match.id);
        btn.disabled = false;
        btn.textContent = 'Añadir al carrito';
      } else {
        btn.disabled = true;
        btn.textContent = match ? 'Agotado' : 'No disponible';
      }
    });

    /* Añadir al carrito sin salir de la página */
    track.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lm-add]');
      if (!btn) return;

      var id = btn.getAttribute('data-lm-add');
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Añadiendo…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Añadido ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });

    /* Respaldo: recomendaciones automáticas de Shopify (solo si el producto no tiene etiquetas o el modo está desactivado) */
    function shopifyRecs() {
      fetch(baseUrl + '?section_id=&product_id=' + productId + '&limit=' + limit + '&intent=' + intent, {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = (data && data.products) || [];
          paint(list.map(cardFromRecs).join(''));
        })
        .catch(function () { root.hidden = true; });
    }

    if (mode !== 'tags' || !wantGender || !wantType) { shopifyRecs(); return; }

    /* Recomendaciones por etiquetas: todo el catálogo publicado (sin colecciones).
       Mismo género (lm-genero) + mismo tipo (lm-tipo); primero el mismo estilo (lm-estilo).
       Los productos "Sin listar" (en test) no salen en /products.json. */
    function getPage(page) {
      return fetch('/products.json?limit=250&page=' + page, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }

    function hasTag(p, tag) {
      var tags = p.tags || [];
      if (typeof tags === 'string') tags = tags.split(',');
      for (var i = 0; i < tags.length; i++) {
        if (String(tags[i]).trim().toLowerCase() === tag) return true;
      }
      return false;
    }

    /* Catálogo resumido, guardado 30 min en la sesión para que las siguientes fichas carguen al momento */
    function slim(p) {
      return {
        id: p.id, title: p.title, handle: p.handle, tags: p.tags,
        images: p.images && p.images.length ? [{ src: p.images[0].src }] : [],
        options: (p.options || []).map(function (o) { return { name: o.name, values: o.values }; }),
        variants: (p.variants || []).map(function (v) {
          return { id: v.id, available: v.available, price: v.price, compare_at_price: v.compare_at_price, option1: v.option1, option2: v.option2, option3: v.option3, img: v.featured_image ? v.featured_image.src : null };
        })
      };
    }
    function getCatalog() {
      var KEY = 'lmRelCatalog2';
      try {
        var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (c && c.t && Date.now() - c.t < 30 * 60 * 1000 && c.p && c.p.length) return Promise.resolve(c.p);
      } catch (err) {}
      return Promise.all([getPage(1), getPage(2), getPage(3)]).then(function (pages) {
        var list = pages[0].concat(pages[1], pages[2]).map(slim);
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), p: list })); } catch (err) {}
        return list;
      });
    }

    getCatalog().then(function (catalog) {
      var seen = {};
      var all = catalog.filter(function (p) {
        if (!p || seen[p.id]) return false;
        seen[p.id] = true;
        if (String(p.id) === productId || p.title === curTitle) return false;
        if (!hasTag(p, wantGender)) return false;
        if (!(p.variants || []).some(function (v) { return v.available; })) return false;
        return hasTag(p, wantType);
      });

      var sameStyle = [];
      var rest = [];
      all.forEach(function (p) {
        if (wantStyle && hasTag(p, wantStyle)) sameStyle.push(p); else rest.push(p);
      });

      var picked = shuffle(sameStyle).concat(shuffle(rest)).slice(0, limit);
      if (!picked.length) { root.hidden = true; return; }
      paint(picked.map(cardFromCatalog).join(''));
    });
  }

  function lmRelAll() { document.querySelectorAll('[data-lm-rel]').forEach(lmRelInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lmRelAll); else lmRelAll();
  document.addEventListener('shopify:section:load', lmRelAll);
})();
